/* eslint-disable react/jsx-indent */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useIntl } from 'hooks';
import { Modal, ModalButtons, ModalContent, Button } from 'mw-style-react';
import cn from 'classnames';
import { CANCEL_LICENSE } from 'constants';
import TextButton from '../../../TextButton';
import mes from './intl';
import sModal from '../../Modal.scss'; // eslint-disable-line no-unused-vars

function CancelLicense(props) {
  const [submitting, setSubmitting] = useState(false);

  const {
    visibility,
    onClose,
    data: { id },
    dispatch
  } = props;

  const t = useIntl();

  const handleSubmit = () => {
    setSubmitting(true);

    dispatch({
      type: CANCEL_LICENSE.REQUEST,
      payload: {
        params: {
          id
        },
        callback: result => {
          if (result === 'error') {
            setSubmitting(false);
          } else {
            setSubmitting(false);
            onClose();
          }
        }
      }
    });
  };

  return (
    <Modal visibility={visibility} onClose={onClose} styleName="sModal.modal__workspace">
      <div styleName="sModal.modal__header">
        <div styleName="sModal.modal__header__close">
          <TextButton title="Cancel" onClick={onClose} />
        </div>
        <div styleName="sModal.modal__header__title">{t(mes.titleCancelLicense)}</div>
      </div>
      <div styleName="sModal.modal__body">
        <ModalContent styleName="sModal.modal__content">
          <div>
            <div styleName="sModal.modal__description">
              Are you sure you want to cancel license? <br />
              The license will remain valid until the end of the paid period, after which it will be
              permanently canceled. This action is irreversible.
            </div>
          </div>
        </ModalContent>
        <ModalButtons styleName="sModal.modal__buttons">
          <Button
            label={t(mes.btnCancelLicense)}
            size="medium"
            onClick={handleSubmit}
            styleName={cn('sModal.modal__btn', 'sModal.red', 'sModal.wide', {
              red__disabled: submitting
            })}
            visibility={submitting ? 'disabled' : 'visible'}
          />
        </ModalButtons>
      </div>
    </Modal>
  );
}

CancelLicense.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  data: PropTypes.object,
  dispatch: PropTypes.func
};

export default CancelLicense;
